export default "__VITE_ASSET__hN_ZTvv1__"